import { FormGroup, ValidatorFn } from '@angular/forms';
import { DialogBoxFormGroup } from './dialog-box-form-group';

export const ActionConfirmationDialogValidator: ValidatorFn = (formGroup: FormGroup<DialogBoxFormGroup>) => {
  if (!formGroup.controls.optionValueFlag) {
    return null;
  }

  if (!formGroup.controls.optionValueFlag.value) {
    return { userValidationRequired: { value: null } };
  }

  return null;
};
